import { useMutation } from 'react-query';
import { useDispatch } from 'react-redux';
import { authFetch } from '../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../CommonUtils/httpBodyOptions';
import { Language, LanguageCode } from '../../CommonSelectors/CommonArea.types';
import { updateConsumerAreaState } from '../../ConsumerArea/ConsumerAreaActions';

interface Params {
  clientId: string;
  languagePreference: Language;
}

const mutateLocalize = ({ clientId, languagePreference }: Params): Promise<string> =>
  authFetch('/Consumer/Localize', {
    method: 'PUT',
    ...httpBodyOptions({ clientId, languagePreference }),
  });

export const useLocalizeMutation = () => {
  const dispatch = useDispatch();

  return useMutation(mutateLocalize, {
    onSuccess(_, { languagePreference }) {
      dispatch(
        updateConsumerAreaState({ languagePreference: LanguageCode[Language[languagePreference]] }),
      );
    },
  });
};
